import moment from "moment";
import React from "react";
import { connect, ConnectedProps } from "react-redux";
import styled from "styled-components";
import { fadeIn } from "sweet-web/lib/animations";
import { colors } from "sweet-web/lib/styles";
import { RootState } from "sweet-web/redux";
import * as selectors from "sweet-web/redux/selectors";
import ChatLine from "./ChatLine";

const Wrapper = styled.div`
  height: 100%;
  border-right: 1px solid ${colors.lightGray};
  min-width: 220px;
  padding: 40px 0;
  overflow: auto;
  ${fadeIn}
  @media screen and (max-width: 600px) {
    border: none;
    width: 100%;
  }
`;

type Props = ConnectedProps<typeof connector>;

const SelectChat: React.FC<Props> = props => {
  const { chatIds } = props;

  return (
    <Wrapper>
      {chatIds.map(chatId => (
        <ChatLine key={`chat-line-${chatId}`} chatId={chatId} />
      ))}
    </Wrapper>
  );
};

const mapState = (state: RootState) => ({
  chatIds: selectors.chatIds(state)
});
const connector = connect(mapState);

export default connector(SelectChat);
